import React from 'react';
const Login = React.lazy(() => import('../containers/auth/login'));
const Register = React.lazy(() => import('../containers/auth/register'));
const Verify = React.lazy(() => import('../containers/auth/verify'));
const Forget = React.lazy(() => import('../containers/auth/forget'));
const Reset = React.lazy(() => import('../containers/auth/reset'));

const routes = [
    {
        path:'/login',
        component: Login,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    },
    {
        path:'/register',
        component: Register,
        layout:'centralize',
        visibility: 'all' //all , guest , trust
    },
    {
        path:'/verify',
        component: Verify,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    },
    {
        path:'/forget',
        component: Forget,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    },
    {
        path:'/reset-password',
        component: Reset,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    }

];
export default routes;